import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import classes from "./CoachDetailsCertificates.module.css";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import {
  BTCALogo,
  LTALogo,
  NATIONALLogo,
  RightLongArrow,
  LeftLongArrow,
} from "../../constant/imagePath";
import Carousel, { consts } from "react-elastic-carousel";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";

// const myArrow = ({ type, onClick, isEdge }) => {
//   const pointer = type === consts.PREV ? LeftLongArrow : RightLongArrow;
//   return (
//     <button
//       onClick={onClick}
//       disabled={isEdge}
//       className={type === consts.PREV ? classes.leftBtn : classes.rightBtn}
//     >
//       <img src={pointer} />
//     </button>
//   );
// };
export const CoachDetailsCertificates = ({ data }) => {
  const ref = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);
  const settings = {
    breakPoints: [
      { width: 1, itemsToShow: 1 },
      { width: 200, itemsToShow: isMobile ? 1 : 3 },
      { width: 550, itemsToShow: isMobile ? 2 : 3 },
      { width: 1200, itemsToShow: 4 },
    ],
  };
  return (
    <>
      <style jsx>{`
        .rec-slider-container {
          margin: 0px;
        }
      `}</style>
      <div className={classes.certificatesContainer}>
        <div className={classes.header}>
          <h4
            style={{
              ...Fonts.h4,
              color: Colors.neutralShadesOfNero,
              fontSize: "26px",
              // fontWeight: 900,
              // if it is included then the font will be same according to XD
            }}
          >
            Certificates
          </h4>
          <div className={`d-flex `}>
            <button
              onClick={() => ref.current.slidePrev()}
              className={classes.leftBtn}
              disabled={currentIndex == 0 && true}
            >
              <img src={LeftLongArrow} />
            </button>
            <button
              onClick={() => ref.current.slideNext()}
              className={classes.rightBtn}
              disabled={currentIndex == data?.length - 3 && true}
            >
              <img src={RightLongArrow} />
            </button>
          </div>
        </div>
        <div className={classes.certificates}>
          <Carousel
            itemsToShow={3}
            itemsToScroll={1}
            pagination={false}
            enableAutoPlay={false}
            itemPadding={[0, 8]}
            ref={ref}
            showArrows={false}
            onNextEnd={(e) => setCurrentIndex(e.index)}
            onNextStart={(e) => setCurrentIndex(e.index)}
            {...settings}
          >
            {data?.map((item) => {
              return (
                <div
                  className={classes.certificateBox}
                  style={{ backgroundColor: Colors.neutralShadesOfWhiteSmoke }}
                  onClick={item?.onClick}
                >
                  <img src={item?.logo} />
                  <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
                    {item?.description}
                  </p>
                </div>
              );
            })}
          </Carousel>
        </div>
      </div>
    </>
  );
};

CoachDetailsCertificates.propTypes = {
  data: PropTypes.array,
};

CoachDetailsCertificates.defaultProps = {
  data: [
    {
      logo: BTCALogo,
      description: "The British Tennis Coaches association",
      onClick: () => console.log(""),
    },
    {
      logo: LTALogo,
      description: "LTA Tennis Coaching Qualification",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
  ],
};
